import { createFileRoute } from '@tanstack/react-router';

import DayToDayForm from 'src/components/DayToDayForm';
import PageHeader from 'src/components/PageHeader';
import { InnerMaxWidthContainer } from 'src/layouts/InnerMaxWidthContainer';

export const Route = createFileRoute('/(app)/care/day-to-day/memory')({
    component: AdlsEditMemoryComponent,
});

function AdlsEditMemoryComponent() {
    return (
        <InnerMaxWidthContainer>
            <PageHeader />
            <DayToDayForm
                dayToDayName="THINKING_MEMORY"
                title={(firstName) =>
                    `Does ${firstName} need help with remembering things or following instructions?`
                }
                description={(firstName) =>
                    `Share any challenges ${firstName} has with remembering things, following instructions, or staying focused.`
                }
                placeholder="e.g., forgets recent events, needs reminders for daily tasks, has trouble following complex directions"
                nextRoute="/care/day-to-day/mobility"
            />
        </InnerMaxWidthContainer>
    );
}
